module.exports = __webpack_public_path__ + "b55ae913a982896139703572a8520de9.svg";